(function (angular) {
  // TODO pchen: refactor this and the identically-named
  //   directive in Common Javascript Files/.../common-directives.js
  //   note: will probably require moving copyrightText outside of
  //   common-directives.js, since the other directives have dependencies
  //   that ALKCloud does not need to require
  //   note 2: I still can't find the ALKCloud page that has a copyright...
  var m = angular.module("copyright.text", []);

  m.directive("copyrightText", function () {
    return {
      scope: {},
      restrict: "AE",
      replace: true,
      template: "<span class=\"copyright-text\">Copyright &copy; 2010-{{year}} Trimble Inc. All Rights Reserved.</span>",
      link: function (scope, elem, attrs) { // jshint ignore:line
        scope.year = new Date().getFullYear();
      }
    };
  });
})(angular);



// WEBPACK FOOTER //
// ./app/components/copyright.directive.js